import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { SxProps } from '@mui/system';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useDownloadFile } from 'hooks/useDownloadFile';
import { FilterValuesProps } from 'hooks/useFilter';
import { RequestOptionsType } from 'hooks/useRequestListagem';

export type DreReportType = 'consolidado' | 'analitico' | 'sintetico';

interface RelatorioBaseFaturamentoBtnProps {
    disabled: boolean;
    reportType: DreReportType;
    filter: FilterValuesProps[];
    label: string;
    sx?: SxProps;
}

export function DreExportarRelatorioBtn({ disabled, reportType, label, filter, sx }: RelatorioBaseFaturamentoBtnProps) {
    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: `/dre/dremercadologica/extrato/${reportType}/exportar`,
            columns: 'idDreMercadologica',
            filter: filter,
        }),
        [filter, reportType],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleClickDownload = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            onClick={handleClickDownload}
            disabled={disabled || isLoadingFile}
            sx={sx}
            startIcon={<RiFileExcel2Fill />}
        >
            {label}
        </Button>
    );
}
